module.exports = __webpack_public_path__ + "SO.png?11ac77aa2f8ab815e6f071bd5bc2b237";